import { queryOptions } from "@tanstack/react-query";
import { type GetCatalog } from "@exonn/js-sdk";
import { getExonnApi } from "src/exonn-api/exonn-api.tsx";

export const exonnHubProductQueries = {
  all: {
    queryKey: ["exonn-hub", "products"] as const,
  },
  lists: () => ({
    queryKey: [...exonnHubProductQueries.all.queryKey, "list"] as const,
  }),
  list: (params: GetCatalog.QueryParameters) =>
    queryOptions({
      queryKey: [...exonnHubProductQueries.lists().queryKey, params] as const,
      queryFn: async ({ signal }) => {
        const api = getExonnApi();
        return (
          await api.supplierProductHub.getCatalog(params, null, {
            signal: signal,
          })
        ).data;
      },
    }),
} as const;
